import React from 'react';
import { Button } from '@components/Button';
import dataLayer from '@helpers/dataLayer';
import './ContactCard.scss';

export interface ContactCardProps {
  title: string;
  description: string;
  buttonText: string;
  typeLink: string;
  enqType: string;
}

export const ContactCard = ({
  title,
  enqType,
  description,
  buttonText,
  typeLink,
}: ContactCardProps) => {
  const loadForm = () => {
    dataLayer.push('contact_button', {
      contact_type: enqType,
    });

    const url = new URL(window.location.toString());
    const newUrl = url.origin + typeLink;
    // quoteOriginPageID is used as parent page id in contact-us/enquiry type form
    localStorage.setItem('quoteOriginPageID', window.pageId);
    localStorage.setItem('quoteOriginPageUrl', window.location.href);
    localStorage.setItem('backButtonUrl', window.location.href);
    window.history.pushState({}, null, newUrl);
    window.history.go();
  };
  return (
    <div className='c-contact-type-card-container c-contact-type-card'>
      <div className='c-contact-type-card-alignmnt'>
        <h3>
          <span className='c-contact-right-arrow'>
            <i className='icon-arrow-right' onClick={loadForm}></i>
          </span>
          {title}
        </h3>
        <p>{description}</p>
      </div>
      <div className='c-contact-type-card-more-btn-new'>
        <Button color='primary' onClick={loadForm} text={buttonText} size='small' />
      </div>
    </div>
  );
};
